export const STATS = {
    // Home page
    all: {
        anchors: 171,
        borrowers: 18169,
        invoices: 402044,
        disbursed: 41490810938.93,
        aum: 4148647759.0,
    },
    // SaralPay Later
    bnpl: {
        anchors: 28,
        borrowers: 1715,
        invoices: 16158,
        disbursed: 11696651025.55,
        aum: 453700800.0,
    },
    // Vendor Finance
    vendor: {
        anchors: 12,
        borrowers: 93,
        invoices: 936,
        disbursed: 11186188956.3,
        aum: 1404426878.0,
    },
    // Supplychain finance
    scf: {
        anchors: 29,
        borrowers: 29,
        invoices: 1518,
        disbursed: 18607970957.08,
        aum: 2290520081.0,
    },
};
